import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/zh-cn/services/regulatory-affairs/authorized-representative-eu-rep")({
  head: () => buildRouteHead("/zh-cn/services/regulatory-affairs/authorized-representative-eu-rep"),
  component: RegulatoryOffering,
});

